import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BASE}/api`;

export const ORG_JWT_KEY = "nailViet.organizerJWT";

/** Dedicated axios instance for organizer-scoped calls.
 *  Carries the organizer JWT — never the admin one. */
export const orgApi = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

orgApi.interceptors.request.use((config) => {
  try {
    const jwt = typeof window !== "undefined" ? localStorage.getItem(ORG_JWT_KEY) : null;
    if (jwt && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${jwt}`;
    }
  } catch (_err) { /* ignore */ }
  return config;
});

orgApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (typeof window !== "undefined") {
      const status = error?.response?.status;
      const url = error?.config?.url || "";
      const isOrgCall = url.includes("/organizer") || url.startsWith("/organizer");
      const onLogin = window.location.pathname.startsWith("/organizer/login")
        || window.location.pathname.startsWith("/organizer/signup");
      if (status === 401 && isOrgCall && !onLogin) {
        try { localStorage.removeItem(ORG_JWT_KEY); } catch (_e) { /* ignore */ }
      }
    }
    return Promise.reject(error);
  }
);

export function saveOrganizerToken(token) {
  if (!token) return;
  localStorage.setItem(ORG_JWT_KEY, token);
}

export function clearOrganizerToken() {
  try { localStorage.removeItem(ORG_JWT_KEY); } catch (_e) { /* ignore */ }
}

export function readOrganizerToken() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(ORG_JWT_KEY);
}
